import api from 'api'

type User = {
  id: number
  name: string
}

type GetUsersRequest = {
  type: 'internal'
  statuses?: ('active' | 'account_created')[]
  roles?: ('sales_owner' | 'account_owner')[]
}

type GetUsersResponse = {
  items: User[]
}

export const getUsers = async (request: GetUsersRequest) => {
  const response = await api.get<GetUsersResponse>('/admin/user/list', {
    params: {
      type: request.type,
      statuses: request.statuses,
      roles: request.roles,
    },
  })
  return response.data.items
}
